import $ from 'jquery';

class Careers {
	constructor() {
		this.officeNode = document.querySelector('.careers__filter--office select');
		this.departmentNode = document.querySelector('.careers__filter--department select');

		const selectrConfig = {
			defaultSelected: false,
			allowDeselect: true,
			clearable: true,
			searchable: true
		}

		if (this.officeNode) {
			this.officeSelectr = new window.Selectr(this.officeNode, $.extend(selectrConfig, {
				placeholder: this.officeNode.getAttribute( 'placeholder' )
			}));
		}
		if (this.departmentNode) {
			this.departmentSelectr = new window.Selectr(this.departmentNode, $.extend(selectrConfig, {
				placeholder: this.departmentNode.getAttribute( 'placeholder' )
			}));
		}

		this.groups = document.querySelector('.careers__groups');
		this.titles = Array.from(document.querySelectorAll('.careers__group-title'));

		if ( this.titles.length > 1 ) {
			this.groups.classList.add('careers__groups--accordion');
			$(this.titles).on('click', function(e) {
				$(this).next().slideToggle(250);
			});
		} else {
			$(this.titles).each(function() {
				$(this).next().show();
			});
		}

		this.apply = document.querySelector('.careers__apply');
		this.content = document.querySelector('.careers__job-content');

		if ( this.apply && this.content && this.apply.dataset.jobid ) {
			const grnhse_app = document.createElement('div');
			grnhse_app.id = 'grnhse_app';
			grnhse_app.className = 'inactive';

			this.content.appendChild(grnhse_app);

			this.apply.addEventListener('click', (e) => {
				if ( !window.Grnhse ) {
					return;
				}

				e.preventDefault();

				this.apply.parentNode.style.transition = 'opacity 400ms ease-in-out';
				this.apply.parentNode.style.opacity = 0;

				window.Grnhse.Settings.scrollOnLoad = false;
				window.Grnhse.Iframe.load( parseInt( this.apply.dataset.jobid, 10 ) );

				$(grnhse_app).slideDown(400, () => {
					grnhse_app.classList.remove('inactive');
				});
			});
		}
	}
}

export default Careers;
